// extracted by mini-css-extract-plugin
module.exports = {"short_codes":"styles_short_codes__3YDzv"};